import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

// §6 — ação simples → sheet/dialog/popover. `Esc` fecha (§39).
export function Sheet({ open, onClose, title, subtitle, footer, children }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;
  return (
    <div className="crm-overlay crm-sheet-overlay" onClick={onClose}>
      <div className="crm-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="crm-modal-header">
          <div>
            <h3 className="crm-modal-title">{title}</h3>
            {subtitle && <div className="crm-form-hint">{subtitle}</div>}
          </div>
          <button className="crm-icon-btn" onClick={onClose} aria-label="Fechar"><FontAwesomeIcon icon={faTimes} /></button>
        </div>
        <div className="crm-modal-body">{children}</div>
        {footer && <div className="crm-modal-footer">{footer}</div>}
      </div>
    </div>
  );
}

export default Sheet;
